import * as React from "react";

interface VersionSummaryProps {
  version: VersionSnakeModel
}

export default function VersionSummary(props: VersionSummaryProps) {
  const {
    version,
  } = props;

  return (
    <div className="panel">
      <h1 className="name">
        <a href={`/versions/${version.id}`}>
          {version.updated_at}
        </a>
      </h1>
      <p>ID: {version.id}</p>
    </div>
  );
}
